/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { GET_DISCOUNT_PRESENTATION } from "../graphql/getDiscountPresentationList.query";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IDiscountPresentationListsMethods extends IPluginMethodMap {
  getDiscountPresentationListsProps(args: any): Promise<any>;
}

export class DiscountPresentationListsService implements IAgentPlugin {
  readonly methods: IDiscountPresentationListsMethods;

  constructor() {
    this.methods = {
      getDiscountPresentationListsProps:
        this.getDiscountPresentationListsProps.bind(this),
    };
  }

  async getDiscountPresentationListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_DISCOUNT_PRESENTATION,
          variables: {
            filter: {
              status: {
                eq: "active",
              },
            },
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        console.log(
          "getDiscountPresentation---",
          res?.data?.getPresentations?.content
        );
        return {
          presentationLists2: this.addProperties(
            this.transformData(res?.data?.getPresentations?.content)
          ),
        };
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private transformData(inputData: any): any[] {
    if (!inputData || inputData.length === 0) {
      return [];
    }

    return inputData.map((item: any) => {
      return {
        id: item?.id,
        name: item?.name,
        status: item?.status || "active",
        sections:
          item?.sections?.map((section: any) => {
            return {
              id: section?.id,
              name: section?.name,
              costumeTypes: section?.costumeTypes || [],
            };
          }) || [],
      };
    });
  }
  addProperties(inputData: any[]): any[] {
    console.log("output---> input", inputData);
    if (!inputData || inputData.length === 0) {
      return [];
    }
    const partitionOption: { id: string; label: string }[] = [
      { id: "Default", label: "Default" },
      { id: "SectionSpecific", label: "SectionSpecific" },
      { id: "SpecialReserve", label: "SpecialReserve" },
    ];

    return inputData.map((obj) => {
      const sections = obj.sections;
      const defaultSectionOptType: { id: string; label: string }[] = [];
      const specialReserveSectionOptType: { id: string; label: string }[] = [];

      sections.forEach((section: any) => {
        section.costumeTypes.forEach((costumeType: any) => {
          const { id, name } = costumeType;
          const option = { id: name, label: name };

          if (!defaultSectionOptType.some((opt) => opt.id === option.id)) {
            defaultSectionOptType.push(option);
          }

          if (
            !specialReserveSectionOptType.some((opt) => opt.id === option.id)
          ) {
            specialReserveSectionOptType.push(option);
          }
        });
      });

      return {
        ...obj,
        defaultSectionOptType,
        specialReserveSectionOptType,
        partitionOption,
        sectionsAndSectionOptType: sections.map((section: any) => {
          const sectionSpecificSectionOptType: { id: string; label: string }[] =
            [];
          section.costumeTypes.forEach((costumeType: any) => {
            const { id, name } = costumeType;
            const option = { id: name, label: name };

            if (
              !sectionSpecificSectionOptType.some((opt) => opt.id === option.id)
            ) {
              sectionSpecificSectionOptType.push(option);
            }

            if (
              !specialReserveSectionOptType.some((opt) => opt.id === option.id)
            ) {
              specialReserveSectionOptType.push(option);
            }
          });

          return {
            id: section.id,
            name: section.name,
            sectionSpecificSectionOptType,
          };
        }),
      };
    });
  }
}
